/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Missed_Mandatory_EffectInputs */



/**
* | output |
* | --- |
* | "Missed Mandatory Effect" |
*
* @param {Sanction_Sub_Missed_Mandatory_EffectInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_missed_mandatory_effect = /** @type {((inputs?: Sanction_Sub_Missed_Mandatory_EffectInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Missed_Mandatory_EffectInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effet Obligatoire Manqué")
	if (locale === "es") return /** @type {LocalizedString} */ ("Efecto Obligatorio No Aplicado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Efeito Obrigatório Perdido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Effetto Obbligatorio Mancato")
	return /** @type {LocalizedString} */ ("Missed Mandatory Effect")
});